import { TypedAnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { ClickTrackingInfo } from "@omni/types/components/tracking/tracking-info/click/click.trackingInfo";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsMinimumDataset,
    getPageInfo,
    getUserInfo
} from "../GoogleAnalyticsMinimumDataset";

export interface GoogleAnalyticsButtonImpression
    extends GoogleAnalyticsMinimumDataset {
    info: {
        name: string;
        category: string;
        placement: string;
        targeturl: string;
        targetname: string;
    };
}

const getGoogleAnalyticsButtonImpression = (
    data: TypedAnalyticsEvent<ClickTrackingInfo>,
    event: GoogleAnalyticsEvents = GoogleAnalyticsEvents.ButtonImpression
): GoogleAnalyticsButtonImpression => {
    const eventData: ClickTrackingInfo = data?.payload.eventData || {};

    return {
        event,
        pageInfo: getPageInfo(data),
        userInfo: getUserInfo(data),
        info: {
            name: eventData.name || "",
            category: eventData.category || "",
            placement: eventData.placement || "",
            targeturl: eventData.targetUrl || "",
            targetname: eventData.targetName || ""
        }
    };
};

export { getGoogleAnalyticsButtonImpression };
